import React, { useState } from "react";
import { tableColumn } from "./tableColumns";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomTitle from "../../custom/CustomTitle";
import ResponsiveTable from "../../custom/table/responsiveTable";
import { GetAllInstallations } from "../../../api/services/installationsService";

type SubscriptionTableProps = {
  SetPopupObject: (obj: any) => void;
  link: (p: string) => string;
};

const SubscriptionsListTable: React.FC<SubscriptionTableProps> = ({
  SetPopupObject,
  link,
}) => {
  const { t } = useTranslation();

  const [data, setData] = useState<Object[]>([]);
  const history = useHistory();
  const linkFunction: (value: string) => void = (value: string) => {
    history.push(link(value));
  };

  return (
    <>
      <CustomTitle title={t("devicesList")} />
      <ResponsiveTable
        columns={tableColumn(t, data, SetPopupObject, linkFunction)}
        getPageAndSortedData={GetAllInstallations}
        defaultSort="name"
        responseDataName="subscriptions"
        setData={setData}
      />
    </>
  );
};

export default SubscriptionsListTable;
